import { useHistory, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Modal from 'common/modal';
import LinearWithValueLabel from 'common/progress';

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
  onActionClick: () => void;
  onExitClick: () => void;
  startingForm: string;
  loading: boolean;
  progress: number;
};

const useStyles = makeStyles(() => ({
  parentContainer: {
    marginBottom: '50px',
  },
  subTitle: {
    marginTop: '25px',
    fontWeight: 'normal',
  },
}));

const IntakeFormModal = ({
  setShowModal,
  showModal,
  onActionClick,
  onExitClick,
  startingForm,
  loading,
  progress,
}: Props) => {
  const CLASSES = useStyles();
  const { portalId } = useParams<Record<string, string>>();
  const content = (
    <>
      <LinearWithValueLabel progress={progress} />

      <iframe
        frameBorder="0"
        height="750px"
        title="jotformModuleA"
        width="100%"
        src={`https://jotform.com/form/${startingForm}?portalid=${portalId}`} // trustate acc form a
      />
    </>
  );

  const successContent = (
    <div className={CLASSES.parentContainer}>
      <img src={'/big-green-check-mark.svg'} alt={'success'} />
      <Typography className={CLASSES.subTitle}>You have completed the Estate Module!</Typography>
    </div>
  );

  const history = useHistory();
  onActionClick = () => history.push(`dashboard`);
  onExitClick = () => history.push(`dashboard`);

  return (
    <Modal
      title={progress === 100 ? 'Success!' : ''}
      actionVerb={progress === 100 ? 'Go to dashboard' : ''}
      hideSecondaryButton
      setShowModal={setShowModal}
      showModal={showModal}
      showActions={progress === 100}
      onActionClick={onActionClick}
      onExitClick={onExitClick}
      content={progress !== 100 ? content : successContent}
      maxWidth="lg"
      loading={loading}
    />
  );
};

export default IntakeFormModal;
